import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular2-toaster';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { LevelService, Level, ITile, ILevelType, ILevelRow } from '../../_service';

import { saveAs } from 'file-saver';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { TilesBarComponent } from '../../layout';
import { environment } from '../../../environments/environment';



@Component({
    moduleId: module.id,
    templateUrl: 'edit.component.html'
})
export class EditComponent implements OnInit, OnDestroy {
    level: Level;
    levelList: string[];
    currentTile: string = " ";
    isLoading: boolean = false;
    levelTypes: ILevelType[];
    selectedLevelType: ILevelType = null;
    selectedLevelTypeId: number = 1;
    levelName: string;
    playUrl: string;

    constructor(private translate: TranslateService,
        private _toasterService: ToasterService,
        private _slimLoadingBarService: SlimLoadingBarService,
        private _levelService: LevelService,
        private sanitizer: DomSanitizer,
        private _route: ActivatedRoute) {

    }

    ngOnInit(): void {
        this.levelName = this._route.snapshot.queryParams['name'] || null;
        this.playUrl = environment.basePozzwareUrl + "WebGame/index.html?"
        if (this.levelName) {
            var elements: string[] = this.levelName.split("@");
            this.selectedLevelTypeId = parseInt(elements[1]);
            this.selectedLevelType = this._levelService.getLevelType(this.selectedLevelTypeId);
            this.resetLevel();
        } else {
            //livello nuovo
        }
    }

    ngOnDestroy(): void {
        Object.keys(this).map(k => {
            this[k] = null;
        });
    }

    setImage(tile: ITile): void {
        tile.type = this.currentTile;
    }

    getLevelWidth(): string {
        return (this.level.Rows[0].tiles.length * 30) + "px";
    }

    getTileImage(tile: ITile): string {
        var tiles = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var path = (this.selectedLevelType && this.selectedLevelType.id) ? this.selectedLevelType.id : 1;
        var special_tiles = "0123456789";
        var objects = "abcdefghijklmnopqrstuvwxyz";
        if (tile.type == " ") return "assets/images/blank.png";
        if (tile.type == "`") return "assets/images/respawn.png";
        if (tile.type == "~") return "assets/images/spawn.png";
        if (tiles.indexOf(tile.type) >= 0) {
            return `assets/images/${path}/Tile_${tile.type}.png`;
        }
        if (special_tiles.indexOf(tile.type) >= 0) {
            return `assets/images/${path}/SpecialTile_${tile.type}.png`;
        }
        if (objects.indexOf(tile.type) >= 0) {
            return `assets/images/${path}/Obj_${tile.type}.png`;
        }
    }

    getLevel(): void {
        var formBlob = new Blob([this.level.getLevelMap()], { type: 'text/plain' });
        saveAs(formBlob, this.selectedLevelType.name + '_level.txt');
    }

    saveLevel(): void {
        this._levelService.saveLevel(this.levelName, this.level.getLevelMap()).subscribe(data => {
            this._toasterService.pop("success", "Saved");
        },
            error => {
                this._toasterService.pop("error", error);
                console.error(error);
            });
    }

    getBackGround(): SafeStyle {
        var path = (this.selectedLevelType && this.selectedLevelType.id) ? this.selectedLevelType.id : 1;
        const url = `assets/images/${path}/Background.png`;
        return this.sanitizer.bypassSecurityTrustStyle(`url(${url})`);
    }

    /*
    onTypeChange(reset: boolean = true) {
        if (this.selectedLevelTypeId > 0) {
            var sel = this.levelTypes.filter((value, idx) => {
                if (value.id == this.selectedLevelTypeId) return value;
            });
            this.selectedLevelType = sel[0];
            if (reset) this.resetLevel();
        }
    }

    
    resetLevel(): void {
        this.level.Rows = [];
        for (var r: number = 0; r < this.rows; r++) {
            let row: ILevelRow = { tiles: [] }
            for (var c: number = 0; c < this.columns; c++) {
                if (r == 14 && c == 10) row.tiles.push({ type: "~" });
                else row.tiles.push({ type: " " });
            }
            this.level.Rows.push(row);
        }

    }
    */

    resetLevel(): void {
        this.isLoading = true;
        this._slimLoadingBarService.start();
        this._levelService.getLevel(this.levelName).subscribe(data => {
            this.level = data;
            this.levelTypes = this._levelService.levelTypes;
            this.isLoading = false;
            this._slimLoadingBarService.complete();
        },
            error => {
                this.isLoading = false;
                this._toasterService.pop("error", error);
                console.error(error);
            });
    }

    clearLevel(): void {
        this.level.Rows.forEach((row, index)=> {
            row.tiles.forEach((tile, idx) => {
                tile.type = " ";
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/edit/edit.component.ts